import { useMutation } from '@tanstack/react-query';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import { DeliveryNoteValidationResultObject } from '~/models/deliveries/deliveryNoteValidationResultUtils';

type ValidateDlnResponse = {
  detail: Array<{
    loc: string[];
    msg: string;
    type: string;
    cat: 'inf' | 'war' | 'err';
  }>;
};

type ValidateBody = Record<string, any>;

/**
 * Validates a ddelivery note.
 *
 * @param {CreateTemplatePayload} templateData - An object containing the template details to be created.
 * @returns {Promise<CreateTemplateResponse>} - A promise that resolves with the API response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note/operation/validate_dln_asset_validate_post
 */
export const validateDlnVestigasFormat = async (validateBody: ValidateBody) => {
  const response = await vestigasApi
    .post(ENDPOINT.DELIVERY_NOTE.VALIDATE(), {
      json: validateBody,
    })
    .json<ValidateDlnResponse>();

  return response.detail.map((item) =>
    DeliveryNoteValidationResultObject.create(item),
  );
};

/**
 * Custom hook for validationg a delivery note using mutations.
 *
 * @returns {Object} An object containing the mutation function and other properties.
 */
export const useMutationValidateDlnVestigasFormat = () => {
  return useMutation({
    mutationFn: async (validateBody: ValidateBody) =>
      validateDlnVestigasFormat(validateBody),
  });
};
